import script from "./record-view-card.vue?vue&type=script&setup=true&lang=js"
export * from "./record-view-card.vue?vue&type=script&setup=true&lang=js"

import "./record-view-card.vue?vue&type=style&index=0&id=5288d0d5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5288d0d5"]])

export default __exports__